import { ColumnDef } from "@tanstack/react-table"
import { User2, Circle } from "lucide-react"
import { Patient } from "../../../lib/types/patient"
import { format } from "date-fns"
import { cn } from "../../../lib/utils"

const statusStyles = {
  active: {
    color: "text-emerald-700 dark:text-emerald-500",
    bg: "bg-emerald-50 dark:bg-emerald-950",
    border: "border-emerald-200/50 dark:border-emerald-900/50",
    icon: "text-emerald-500 dark:text-emerald-400"
  },
  inactive: {
    color: "text-gray-700 dark:text-gray-400",
    bg: "bg-gray-50 dark:bg-gray-900",
    border: "border-gray-200/50 dark:border-gray-800/50",
    icon: "text-gray-400 dark:text-gray-500"
  },
  pending: {
    color: "text-amber-700 dark:text-amber-500",
    bg: "bg-amber-50 dark:bg-amber-950",
    border: "border-amber-200/50 dark:border-amber-900/50",
    icon: "text-amber-500 dark:text-amber-400"
  }
}

export const columns: ColumnDef<Patient>[] = [
  {
    accessorKey: "firstName",
    header: "First Name",
    cell: ({ row }) => (
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
          <User2 className="w-4 h-4 text-primary/70" />
        </div>
        <span className="font-medium">{row.original.firstName}</span>
      </div>
    )
  },
  {
    accessorKey: "lastName",
    header: "Last Name",
    cell: ({ row }) => <span className="font-medium">{row.original.lastName}</span>
  },
  {
    accessorKey: "dateOfBirth",
    header: "Date of Birth",
    cell: ({ row }) => (
      <span className="text-muted-foreground">
        {format(new Date(row.original.dateOfBirth), "MMM dd, yyyy")}
      </span>
    )
  },
  {
    accessorKey: "gender",
    header: "Gender",
    cell: ({ row }) => (
      <span className="capitalize text-muted-foreground">
        {row.original.gender}
      </span>
    )
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const status = row.original.status.toLowerCase() as keyof typeof statusStyles
      const style = statusStyles[status]
      
      return (
        <div className={cn(
          "flex items-center gap-2 w-fit px-2.5 py-1 rounded-full border",
          style.bg,
          style.border
        )}>
          <Circle className={cn("w-2 h-2", style.icon)} />
          <span className={cn("text-sm font-medium capitalize", style.color)}>
            {status}
          </span>
        </div>
      )
    }
  },
]
